<template>
    <b-container>
        <Head>
            <title>Next Gen Math - {{ title }}</title>
            <meta name="description" content="">
        </Head>
        
        <ribbon-banner>
            <h2 slot="subMenuOf" class="subMenuOf">{{ subMenuOf }}</h2>
            <h1 slot="title">{{ title }}</h1>
        </ribbon-banner>
        
        <article class="my-5">
            <b-row>
                <b-col cols="12" md="10" class="mx-auto">
                    <article>
                        <p class="raised-cap">
                            NextGenMath.com provides educators with unlimited formative (clustering standards), summative (domain aligned), and diagnostic (standard progression aligned) assessments that are pre-made or teacher authored. All items reflect the rigor of Common Core and include a variety of distractors and question formats for each standard. Unlimited retake assessments are generated in three clicks and provide instant data to monitor student progress towards meeting and exceeding the standards. All standards and assessments are color coded as major, priority, minor or supporting. Assessments are authored with one or more standard(s) with multiple stems, and with multiple questions from the same standard and question type. On average, assessments take less than 40 seconds to create and assign.
                        </p>
                    </article>
                    <b-row>
                        <b-col cols="12">
                            <b-img :src="`${routes.cdn_url}/images/redesign/steamCareers/mechanic.svg`" class="steam-career mt-0" alt="A friendly mechanic waves to you as they work on a car. A pegboard in the background stores wrenches of various sizes: one-eighth inch, one-quarter inch, one-half inch, and one inch."></b-img>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h2>Standards Assessments</h2>
                            <p>
                                Check for understanding daily by designing your Standards Assessment. Design your own assessment based on the standards that you are teaching or use the recommended learning paths from assessment data to tailor an assessment to individual students' needs. Each standard has multiple question formats to ensure that the full range of the standard is assessed.
                            </p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h2>Cluster Assessments</h2>
                            <p>
                                Obtain weekly or biweekly progress updates with ready-made Cluster Assessments. Cluster assessments include a cluster of related standards and serve as the ideal formative assessment. Color coding makes it easy to identify priority and supporting clusters.
                            </p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h2>Summative Benchmarks</h2>
                            <p>
                                NextGenMath.com makes it easy to monitor overall progress every six to eight weeks with our Summative Benchmarks. Select from unlimited versions of summative assessments organized by domain and designed to prepare students for the rigor of Common Core Math.
                            </p>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </article>
    </b-container>
</template>

<script>
    import RibbonBanner from '../components/RibbonBanner.vue';

    export default {
        components: {
            RibbonBanner,
        },
        data: () => ({
            subMenuOf: 'Why Next Gen Math?',
            title: 'Dynamic Assessments'
        })
    }
</script>

<style lang="scss" scoped>
</style>
